import { render, staticRenderFns } from "./HorizontalCalendar.vue?vue&type=template&id=248fcbaa&lang=pug"
import script from "./HorizontalCalendar.vue?vue&type=script&lang=js"
export * from "./HorizontalCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports